import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";

interface ScrollToBottomButtonProps {
  onClick: () => void;
}

export const ScrollToBottomButton = ({
  onClick,
}: ScrollToBottomButtonProps) => (
  <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 flex flex-col items-center">
    <div className="pointer-events-auto relative z-20 mb-[15px] flex size-8 items-center justify-center rounded-full border border-primary bg-primary shadow-sm transition-colors hover:bg-secondary">
      <button
        type="button"
        onClick={onClick}
        className="flex size-full items-center justify-center"
        aria-label={t("help_widget.tooltip.scroll_to_bottom")}
      >
        <Icon type="20-chevron-down" size={20} className="text-default" />
      </button>
    </div>
    <div
      className="absolute bottom-0 -z-10 h-9 w-full opacity-80"
      style={{
        background:
          "linear-gradient(to top, var(--color-background-primary) 0%, transparent 100%)",
      }}
    />
  </div>
);
